import { DEFAULT_GAME_SLOT_LENGTH_SECONDS as SHARED_DEFAULT_GAME_SLOT_LENGTH_SECONDS } from '../../../../../../pure-js/libs/SprintActivityGameOptions'
import { Activity, ActivityType } from '../types'

export const DEFAULT_GAME_SLOT_LENGTH_SECONDS = SHARED_DEFAULT_GAME_SLOT_LENGTH_SECONDS
export const DEFAULT_GAME_LOOP_DISPLAY_MINUTES = 20

// Runtime cache populated by useSprintWizardConfig once Firestore data loads
let _activityTemplates: Activity[] = []

export const setActivityTemplates = (activities: Activity[]) => {
  _activityTemplates = activities
}

export const getActivityTemplates = (): Activity[] => _activityTemplates

export const getActivityTemplateByType = (type: ActivityType): Activity | undefined =>
  _activityTemplates.find((activity) => activity.type === type)
